import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { SPACE_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'

export interface Props {
  spaceId: string
  children: () => ReactElement
  onSuccess: () => void
}

const DeleteSpaceRequest = ({
  spaceId,
  onSuccess,
  children
}: Props) => {
  const url = `${SPACE_SERVICE}/spaces/${spaceId}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default DeleteSpaceRequest
